import React from 'react';
import * as S from './styles';
import { IconInfo, InlineNotification } from '@veneer/core';
import { useTranslationHelper } from 'src/contexts/dependencyManager/utils';
import { HPprinter, HPink } from 'src/assets/images';

const UpgradeDetailsOnly: React.FC = () => {
  const getText = useTranslationHelper();
  const noMobileApp = true;
  return (
    <S.DetailsCard>
      <S.DetailsCardTitleAndSubtitle>
        <S.DetailsCardTitle>
          {' '}
          {getText(
            'confirmation.successMessage',
            "You've successfully upgraded to this new plan."
          )}
        </S.DetailsCardTitle>
        <S.DetailsCardSubtitle>
          {' '}
          {getText(
            'confirmation.description',
            'Your subscription will begin once the printer ships to you.'
          )}
        </S.DetailsCardSubtitle>
        {noMobileApp && (
          <S.DetailsCardSubtitle>
            {getText(
              'confirmation.description2',
              'The plan change you requested before making the upgrade process will be lost and replaced with this new one.'
            )}
          </S.DetailsCardSubtitle>
        )}
      </S.DetailsCardTitleAndSubtitle>
      <S.SubscriptionPlanItems>
        <S.ItemSection>
          <S.ImageSection>
            <S.ItemImage
              src={HPprinter}
              alt="HP Smart"
            />
          </S.ImageSection>
          <S.ItemTitle>
            {getText('confirmation.printerTitle', 'HP Smart Tank')}
          </S.ItemTitle>
        </S.ItemSection>
        <S.ItemSection>
          <S.ImageSection>
            <S.ItemImage
              src={HPink}
              alt="HP Ink"
            />
          </S.ImageSection>
          <S.ItemTitle>
            {getText(
              'confirmation.printerPages',
              'Print plan: 300 pages/month'
            )}
          </S.ItemTitle>
        </S.ItemSection>
        <S.PlanNotification>
          <InlineNotification
            description={getText(
              'confirmation.planBadge',
              'You can adjust your upgrade print plan once the upgrade begins.'
            )}
            type="custom"
            icon={
              <S.IconNotification>
                <IconInfo filled />
              </S.IconNotification>
            }
            customStyle={{ backgroundColor: '#E9EFF7' }}
            closeButton={false}
          />
        </S.PlanNotification>
      </S.SubscriptionPlanItems>
    </S.DetailsCard>
  );
};

export default UpgradeDetailsOnly;
